<template>
  <div class="container">
    <img class="jupiter bg-item" src="~@/assets/jupiter.svg" alt="">
    <div class="ufo bg-item">
      <img class="float" src="~@/assets/ufo.svg" alt="">
    </div>
    <div class="asteroid bg-item">
      <img src="~@/assets/astero.svg" alt="">
    </div>
    <div class="spaceship bg-item">
      <img src="~@/assets/spaceship.svg" alt="">
    </div>
    <div class="satellite bg-item">
      <img class="radial" src="~@/assets/satellite.svg" alt="">
    </div>
    <div class="orta">
      <h1 class="state1" v-show="state == 1">
        <span class="text-wrapper">
          <span class="letter">1</span>
          <span class="letter">3</span>
          <span class="letter">&nbsp;</span>
          <span class="letter">C</span>
          <span class="letter">O</span>
          <span class="letter">U</span>
          <span class="letter">N</span>
          <span class="letter">T</span>
          <span class="letter">R</span>
          <span class="letter">I</span>
          <span class="letter">E</span>
          <span class="letter">S</span>
        </span>
      </h1>
      <h1 class="state2" v-show="state == 2">
        <span class="text-wrapper">
          <span class="letter">1</span>
          <span class="letter">3</span>
          <span class="letter">&nbsp;</span>
          <span class="letter">D</span>
          <span class="letter">E</span>
          <span class="letter">S</span>
          <span class="letter">I</span>
          <span class="letter">G</span>
          <span class="letter">N</span>
          <span class="letter">E</span>
          <span class="letter">R</span>
          <span class="letter">S</span>
        </span>
      </h1>
      <h1 class="state3" v-show="state == 3">
        <span class="text-wrapper">
          <span class="letter">1</span>
          <span class="letter">3</span>
          <span class="letter">&nbsp;</span>
          <span class="letter">C</span>
          <span class="letter">O</span>
          <span class="letter">L</span>
          <span class="letter">O</span>
          <span class="letter">R</span>
          <span class="letter">&nbsp;</span>
          <span class="letter">P</span>
          <span class="letter">A</span>
          <span class="letter">L</span>
          <span class="letter">E</span>
          <span class="letter">T</span>
          <span class="letter">T</span>
          <span class="letter">E</span>
          <span class="letter">S</span>
        </span>
      </h1>
      <h1 class="state4" v-show="state == 4">
        <span class="text-wrapper">
          <span class="letter">F</span>
          <span class="letter">L</span>
          <span class="letter">A</span>
          <span class="letter">T</span>
          <span class="letter">&nbsp;</span>
          <span class="letter">U</span>
          <span class="letter">I</span>
          <span class="letter">&nbsp;</span>
          <span class="letter">C</span>
          <span class="letter">O</span>
          <span class="letter">L</span>
          <span class="letter">O</span>
          <span class="letter">R</span>
          <span class="letter">S</span>
        </span>
      </h1>
      <h1 class="state4 state4-big" v-show="state == 4">
        <span class="text-wrapper">
          <span class="letter">
            2
          </span>
        </span>
      </h1>
      <div class="world-flags">
        <img class="world animated bounceIn" src="~@/assets/world.svg" alt="">
        <div class="flags" :class="{'animation-time' : state !== 1}">
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/au.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/ca.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/cn.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/de.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/es.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/fr.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/in.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/ne.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/ru.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/se.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/tr.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/uk.svg" alt=""></div>
          <div class="flag"><img class="animated bounceIn" src="~@/assets/flags/us.svg" alt=""></div>
        </div>
      </div>
    </div>
    <!-- eof .orta -->
    <transition name="fade">
      <Fireworks v-if="showFireworks" />
    </transition>

    <transition name="fade">
      <div class="skip" v-if="state >= 3 && false" @click="goToPalettes();onboardingSkipped = true;">
        Skip Onboarding →
      </div>
    </transition>
  </div>
</template>

<script>
import anime from "animejs";
import Fireworks from "@/components/Fireworks";
import router from "@/router";
import { mapMutations } from "vuex";

export default {
  name: "Onboarding",
  components: { Fireworks },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      state: 1,
      showFireworks: false,
      showLoader: false,
      onboardingSkipped: false
    };
  },
  mounted() {
    this.animateHeader();
    $crisp.push(["do", "chat:hide"]);
  },
  beforeDestroy() {
    setTimeout(() => {
      let interval_id = window.setInterval("", 9999); // Get a reference to the last
      for (var i = 1; i < interval_id; i++) {
        window.clearInterval(i);
      }
    }, 3000);
  },
  methods: {
    ...mapMutations(["toggleLoading"]),
    goToPalettes: function() {
      // console.log("should go to palettes");
      const that = this;
      setTimeout(function() {
        // console.log("loader init");
        that.showLoader = true;
        that.toggleLoading();
      }, 1000);
      setTimeout(() => {
        // console.log("7s passed, go to palettes");
        router.push({ path: "/" });
      }, 1500);
    },
    animateHeader: function() {
      // if (that.state === 1)
      // return;
      // console.log(this.state);
      const that = this;
      if (that.state === 4) {
        setTimeout(function() {
          that.showFireworks = true;
          // console.log("showFireworks", that.showFireworks);
          setTimeout(function() {
            that.showFireworks = false;
            // console.log("showFireworks", that.showFireworks);
            that.goToPalettes();
          }, 4500);
        }, 1000);

        let element = document.getElementsByClassName("world-flags")[0];
        let flagsScaleNum =
          element.getBoundingClientRect().width / element.offsetWidth;
        anime.timeline().add({
          targets: ".state4-big",
          scale: [
            6,
            parseFloat(flagsScaleNum) < 1 ? 1 : parseFloat(flagsScaleNum)
          ],
          opacity: [0, 1],
          elasticity: 400,
          duration: 2000,
          delay: 700
        });
        anime.timeline().add({
          targets: ".world-flags",
          scale: [parseFloat(flagsScaleNum), 0],
          opacity: [1, 0],
          easing: "easeOutExpo",
          duration: 2400,
          delay: 0
        });
      }
      let anim = anime
        .timeline({ loop: false })
        .add({
          targets: `.state${that.state}:not(.state4-big) .letter`,
          scale: [0, 1],
          duration: 1500,
          elasticity: 600,
          delay: function(el, i) {
            return 45 * (i + 1);
          }
        })
        .add({
          targets: `.state${that.state}:not(.state4-big) .letter`,
          opacity: 0,
          scale: [1, 0.7],
          duration: 1000,
          elasticity: 600,
          easing: "easeOutExpo",
          delay: function(el, i) {
            return 45 * (i + 1);
          },
          begin: function() {
            if (that.state == 4) anim.pause();
          },
          complete: function() {
            if (that.state != 4 && !this.onboardingSkipped) {
              that.state++;
              that.animateHeader();
            }
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container {
  background-color: #3537f5;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-image: url("~@/assets/stars.svg");
  display: flex;
  align-items: center;
  justify-content: center;
  // background: green;
  .skip {
    width: 200px;
    text-align: center;
    position: fixed;
    bottom: 20px;
    color: #fff;
    letter-spacing: 1.4px;
    cursor: pointer;
  }
  .orta {
    float: left;
    // background: red;
  }
  .bg-item {
    transform: scale(1.4);
    position: absolute;
    &.jupiter {
      left: 6%;
      top: 10%;
    }
    &.ufo {
      left: 8%;
      bottom: 12%;
      width: 100px;
      height: 100px;
      img {
        position: relative;
        display: block;
      }
    }
    &.satellite {
      right: 20%;
      bottom: 15%;
      width: 100px;
      height: 100px;
      img {
        position: relative;
        display: block;
      }
    }
    &.spaceship {
      right: 10%;
      bottom: 45%;
      img {
        position: relative;
        animation: spaceshippin 300s linear forwards;
      }
    }
    &.asteroid {
      right: 3%;
      top: 5%;
      transform: rotate(-45deg);
      img {
        position: relative;
        animation: asteroiddin 500s linear forwards;
      }
    }
  }
}

// Heading 🔤
h1 {
  position: relative;
  font-weight: 200;
  font-size: 4em;
  font-family: "Luckiest Guy";
  color: #fff;
  transform-origin: 50% 0%;
  transform: scale(2);
  text-align: center;
  text-shadow: 3px 3px 0 #252f6b, -1px -1px 0 #252f6b, 1px -1px 0 #252f6b,
    -1px 1px 0 #252f6b, 1px 1px 0 #252f6b;
  display: block;
  top: -200px;
  .text-wrapper {
    position: relative;
    display: inline-block;
    padding-top: 0.2em;
    padding-right: 0.05em;
    padding-bottom: 0.1em;
    overflow: hidden;
    height: 90px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .letter {
    transform-origin: 50% 100%;
    display: inline-block;
    line-height: 1em;
    margin-right: -6px;
    &:last-child {
      margin-right: 0px;
    }
  }
  &.state4 {
    font-size: 82px;
    z-index: 100;
    margin-top: 70px;
    top: 0px;
    .text-wrapper {
      height: 110px;
    }
  }
  &.state4-big {
    font-size: 242px;
    margin: 0;
    position: relative;
    top: 150px;
    z-index: 100;
    .text-wrapper {
      height: 250px;
    }
  }
}

//🌎 🇪🇸 🇹🇷
.world-flags {
  width: 400px;
  margin: 0 auto;
  transform: scale(1.4);
  transform-origin: 50% 50%;
  // background: yellow;
  padding-bottom: 130px;
  position: relative;
  img {
    position: relative;
    left: 0px;
    top: 0px;
  }
  .world {
    left: 65px;
    top: 100px;
  }
  .flags {
    animation-delay: 0.2s;
    transform-origin: 50% 50%;
    width: 232px * 2;
    height: 232px * 2;
    // background: red;
    left: -35px;
    top: -2px;
    z-index: -1;
    position: absolute;
    &.animation-time {
      animation: rotate360 8s ease-in;
    }
    .flag {
      width: 52px;
      height: 232px;
      left: 204px;
      position: absolute;
      transform-origin: bottom center;
      $delay: 2;
      &:nth-child(1) {
        &:before {
          width: 52px;
          height: 52px;
          background: url("~@/assets/flags/au.svg");
          animation-delay: 0.1s * $delay;
          animation-duration: 0.75s;
          content: " ";
          display: block;
          position: absolute;
          animation-name: bounceIn;
          display: none;
        }
      }
      &:nth-child(2) {
        transform: rotate(28deg);
        img {
          animation-delay: 0.2s * $delay;
        }
      }
      &:nth-child(3) {
        transform: rotate(28deg * 2);
        img {
          animation-delay: 0.3s * $delay;
        }
      }
      &:nth-child(4) {
        transform: rotate(28deg * 3);
        img {
          animation-delay: 0.4s * $delay;
        }
      }
      &:nth-child(5) {
        transform: rotate(28deg * 4);
        img {
          animation-delay: 0.5s * $delay;
        }
      }
      &:nth-child(6) {
        transform: rotate(28deg * 5);
        img {
          animation-delay: 0.6s * $delay;
        }
      }
      &:nth-child(7) {
        transform: rotate(28deg * 6);
        img {
          animation-delay: 0.7s * $delay;
        }
      }
      &:nth-child(8) {
        transform: rotate(28deg * 7);
        img {
          animation-delay: 0.8s * $delay;
        }
      }
      &:nth-child(9) {
        transform: rotate(28deg * 8);
        img {
          animation-delay: 0.9s * $delay;
        }
      }
      &:nth-child(10) {
        transform: rotate(28deg * 9);
        img {
          animation-delay: 1.1s * $delay;
        }
      }
      &:nth-child(11) {
        transform: rotate(28deg * 10);
        img {
          animation-delay: 1.2s * $delay;
        }
      }
      &:nth-child(12) {
        transform: rotate(28deg * 11);
        img {
          animation-delay: 1.3s * $delay;
        }
      }
      &:nth-child(13) {
        transform: rotate(28deg * 12);
        img {
          animation-delay: 1.4s * $delay;
        }
      }
    }
  }
}

//RESPONSIVE
//12" TO 15"
@media (min-height: 780px) and (max-height: 960px) {
  h1 {
    transform: scale(1.5);
    top: -120px;
    &.state4 {
      top: 120px;
    }
    &.state4-big {
      transform: scale(2);
      top: 220px;
    }
  }
  .world-flags {
    transform: scale(1);
    // margin-top: -50px;
    // top: 300px;
  }
  .container .bg-item {
    transform: scale(1);
    &.asteroid {
      transform: rotate(-45deg) scale(1);
    }
  }
}

//UP TO 12"
@media (max-height: 780px) {
  h1 {
    transform: scale(1);
    top: 0px;
    &.state4 {
      top: 180px;
    }
    &.state4-big {
      top: 200px;
    }
  }
  .world-flags {
    transform: scale(0.7);
    // margin-top: 0px;
    // top: 200px;
  }
  .container .bg-item {
    transform: scale(0.8);
    &.asteroid {
      transform: rotate(-45deg) scale(0.8);
    }
  }
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.bounceIn {
  animation-name: bounceIn;
  animation-duration: 0.75s;
}

@keyframes asteroiddin {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-2000%);
  }
}

@keyframes spaceshippin {
  0% {
    transform: translateX(-200%);
  }
  100% {
    transform: translateX(2000%);
  }
}

@keyframes rotate360 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(720deg);
  }
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 0.75s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.radial {
  animation: radial 60s infinite linear normal;
}

@keyframes radial {
  0% {
    transform: rotate(0deg) translateX(100px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(100px) rotate(-360deg);
  }
}

.float {
  animation: float 3s infinite;
}
@keyframes float {
  0% {
    transform: translateY(0%);
  }
  50% {
    transform: translateY(15%);
  }
  100% {
    transform: translateY(0%);
  }
}

.fly {
  animation: fly 2.7s;
}

@keyframes fly {
  0% {
    transform: scale(0.7) rotate(-18deg) translateX(-234px);
  }
  30% {
    transform: scale(0.7) rotate(-18deg) translateX(34px);
  }
  60% {
    transform: scale(0.34) rotate(0) translate(-223px, -70px);
    z-index: 3;
  }
  61%,
  79% {
    z-index: 1;
  }
  80% {
    transform: scale(0.7) rotate(7deg) translate(160px, 70px);
    z-index: 3;
  }
}

@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Onboarding.vue